/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateBrightDataISPProxyRequest,
  CreateProxyFromUrlRequest,
  HTTPValidationError,
  ProxyResponse,
  UpdateProxyRequest,
} from '../models/index';
import {
    CreateBrightDataISPProxyRequestFromJSON,
    CreateBrightDataISPProxyRequestToJSON,
    CreateProxyFromUrlRequestFromJSON,
    CreateProxyFromUrlRequestToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    ProxyResponseFromJSON,
    ProxyResponseToJSON,
    UpdateProxyRequestFromJSON,
    UpdateProxyRequestToJSON,
} from '../models/index';

export interface AddPersonasToProxyApiProxiesProxyIdPersonasPostRequest {
    proxyId: number;
    requestBody: Array<string | null>;
    xApiKey?: string | null;
}

export interface CreateBrightDataIspProxyApiProxiesBrightDataIspCreatePostRequest {
    createBrightDataISPProxyRequest: CreateBrightDataISPProxyRequest;
    xApiKey?: string | null;
}

export interface CreateProxyFromUrlApiProxiesPostRequest {
    createProxyFromUrlRequest: CreateProxyFromUrlRequest;
    xApiKey?: string | null;
}

export interface DeleteProxyApiProxiesProxyIdDeleteRequest {
    proxyId: number;
    xApiKey?: string | null;
}

export interface GetBrightDataIspCountriesApiProxiesIspCountriesGetRequest {
    xApiKey?: string | null;
}

export interface GetProxiesApiProxiesGetRequest {
    xApiKey?: string | null;
}

export interface GetProxyApiProxiesProxyIdGetRequest {
    proxyId: number;
    xApiKey?: string | null;
}

export interface GetProxyPersonasApiProxiesProxyIdPersonasGetRequest {
    proxyId: number;
    xApiKey?: string | null;
}

export interface UpdateProxyApiProxiesProxyIdPutRequest {
    proxyId: number;
    updateProxyRequest: UpdateProxyRequest;
    xApiKey?: string | null;
}

/**
 * 
 */
export class ProxiesApi extends runtime.BaseAPI {

    /**
     * Add a persona to a proxy
     * Add Personas To Proxy
     */
    async addPersonasToProxyApiProxiesProxyIdPersonasPostRaw(requestParameters: AddPersonasToProxyApiProxiesProxyIdPersonasPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string | null>>> {
        if (requestParameters['proxyId'] == null) {
            throw new runtime.RequiredError(
                'proxyId',
                'Required parameter "proxyId" was null or undefined when calling addPersonasToProxyApiProxiesProxyIdPersonasPost().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling addPersonasToProxyApiProxiesProxyIdPersonasPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/proxies/{proxy_id}/personas`;
        urlPath = urlPath.replace(`{${"proxy_id"}}`, encodeURIComponent(String(requestParameters['proxyId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Add a persona to a proxy
     * Add Personas To Proxy
     */
    async addPersonasToProxyApiProxiesProxyIdPersonasPost(requestParameters: AddPersonasToProxyApiProxiesProxyIdPersonasPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string | null>> {
        const response = await this.addPersonasToProxyApiProxiesProxyIdPersonasPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new ISP proxy
     * Create Bright Data Isp Proxy
     */
    async createBrightDataIspProxyApiProxiesBrightDataIspCreatePostRaw(requestParameters: CreateBrightDataIspProxyApiProxiesBrightDataIspCreatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProxyResponse>> {
        if (requestParameters['createBrightDataISPProxyRequest'] == null) {
            throw new runtime.RequiredError(
                'createBrightDataISPProxyRequest',
                'Required parameter "createBrightDataISPProxyRequest" was null or undefined when calling createBrightDataIspProxyApiProxiesBrightDataIspCreatePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/proxies/bright_data/isp/create`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateBrightDataISPProxyRequestToJSON(requestParameters['createBrightDataISPProxyRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProxyResponseFromJSON(jsonValue));
    }

    /**
     * Create a new ISP proxy
     * Create Bright Data Isp Proxy
     */
    async createBrightDataIspProxyApiProxiesBrightDataIspCreatePost(requestParameters: CreateBrightDataIspProxyApiProxiesBrightDataIspCreatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProxyResponse> {
        const response = await this.createBrightDataIspProxyApiProxiesBrightDataIspCreatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new proxy
     * Create Proxy From Url
     */
    async createProxyFromUrlApiProxiesPostRaw(requestParameters: CreateProxyFromUrlApiProxiesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProxyResponse>> {
        if (requestParameters['createProxyFromUrlRequest'] == null) {
            throw new runtime.RequiredError(
                'createProxyFromUrlRequest',
                'Required parameter "createProxyFromUrlRequest" was null or undefined when calling createProxyFromUrlApiProxiesPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/proxies`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateProxyFromUrlRequestToJSON(requestParameters['createProxyFromUrlRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProxyResponseFromJSON(jsonValue));
    }

    /**
     * Create a new proxy
     * Create Proxy From Url
     */
    async createProxyFromUrlApiProxiesPost(requestParameters: CreateProxyFromUrlApiProxiesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProxyResponse> {
        const response = await this.createProxyFromUrlApiProxiesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a proxy
     * Delete Proxy
     */
    async deleteProxyApiProxiesProxyIdDeleteRaw(requestParameters: DeleteProxyApiProxiesProxyIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['proxyId'] == null) {
            throw new runtime.RequiredError(
                'proxyId',
                'Required parameter "proxyId" was null or undefined when calling deleteProxyApiProxiesProxyIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/proxies/{proxy_id}`;
        urlPath = urlPath.replace(`{${"proxy_id"}}`, encodeURIComponent(String(requestParameters['proxyId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Delete a proxy
     * Delete Proxy
     */
    async deleteProxyApiProxiesProxyIdDelete(requestParameters: DeleteProxyApiProxiesProxyIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.deleteProxyApiProxiesProxyIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all ISP countries
     * Get Bright Data Isp Countries
     */
    async getBrightDataIspCountriesApiProxiesIspCountriesGetRaw(requestParameters: GetBrightDataIspCountriesApiProxiesIspCountriesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: string | null; }>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/proxies/isp/countries`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get all ISP countries
     * Get Bright Data Isp Countries
     */
    async getBrightDataIspCountriesApiProxiesIspCountriesGet(requestParameters: GetBrightDataIspCountriesApiProxiesIspCountriesGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: string | null; }> {
        const response = await this.getBrightDataIspCountriesApiProxiesIspCountriesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all proxies
     * Get Proxies
     */
    async getProxiesApiProxiesGetRaw(requestParameters: GetProxiesApiProxiesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ProxyResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/proxies`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProxyResponseFromJSON));
    }

    /**
     * Get all proxies
     * Get Proxies
     */
    async getProxiesApiProxiesGet(requestParameters: GetProxiesApiProxiesGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ProxyResponse>> {
        const response = await this.getProxiesApiProxiesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a specific proxy by ID
     * Get Proxy
     */
    async getProxyApiProxiesProxyIdGetRaw(requestParameters: GetProxyApiProxiesProxyIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProxyResponse>> {
        if (requestParameters['proxyId'] == null) {
            throw new runtime.RequiredError(
                'proxyId',
                'Required parameter "proxyId" was null or undefined when calling getProxyApiProxiesProxyIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/proxies/{proxy_id}`;
        urlPath = urlPath.replace(`{${"proxy_id"}}`, encodeURIComponent(String(requestParameters['proxyId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProxyResponseFromJSON(jsonValue));
    }

    /**
     * Get a specific proxy by ID
     * Get Proxy
     */
    async getProxyApiProxiesProxyIdGet(requestParameters: GetProxyApiProxiesProxyIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProxyResponse> {
        const response = await this.getProxyApiProxiesProxyIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all personas associated with a proxy
     * Get Proxy Personas
     */
    async getProxyPersonasApiProxiesProxyIdPersonasGetRaw(requestParameters: GetProxyPersonasApiProxiesProxyIdPersonasGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string | null>>> {
        if (requestParameters['proxyId'] == null) {
            throw new runtime.RequiredError(
                'proxyId',
                'Required parameter "proxyId" was null or undefined when calling getProxyPersonasApiProxiesProxyIdPersonasGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/proxies/{proxy_id}/personas`;
        urlPath = urlPath.replace(`{${"proxy_id"}}`, encodeURIComponent(String(requestParameters['proxyId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get all personas associated with a proxy
     * Get Proxy Personas
     */
    async getProxyPersonasApiProxiesProxyIdPersonasGet(requestParameters: GetProxyPersonasApiProxiesProxyIdPersonasGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string | null>> {
        const response = await this.getProxyPersonasApiProxiesProxyIdPersonasGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing proxy
     * Update Proxy
     */
    async updateProxyApiProxiesProxyIdPutRaw(requestParameters: UpdateProxyApiProxiesProxyIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProxyResponse>> {
        if (requestParameters['proxyId'] == null) {
            throw new runtime.RequiredError(
                'proxyId',
                'Required parameter "proxyId" was null or undefined when calling updateProxyApiProxiesProxyIdPut().'
            );
        }

        if (requestParameters['updateProxyRequest'] == null) {
            throw new runtime.RequiredError(
                'updateProxyRequest',
                'Required parameter "updateProxyRequest" was null or undefined when calling updateProxyApiProxiesProxyIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/proxies/{proxy_id}`;
        urlPath = urlPath.replace(`{${"proxy_id"}}`, encodeURIComponent(String(requestParameters['proxyId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateProxyRequestToJSON(requestParameters['updateProxyRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProxyResponseFromJSON(jsonValue));
    }

    /**
     * Update an existing proxy
     * Update Proxy
     */
    async updateProxyApiProxiesProxyIdPut(requestParameters: UpdateProxyApiProxiesProxyIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProxyResponse> {
        const response = await this.updateProxyApiProxiesProxyIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
